module.exports = __webpack_public_path__ + "assets/media/morning.6c6509a4.mp3";